import React from 'react';
import { Link } from "react-router-dom";
import ProxyConfirmationStatus from "./ProxyConfirmationStatus";
import Error from './Error';
import StatusBanner from '../common/StatusBanner';
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { EPIC, RX, RXEPIC, REQUEST, GRANT, REQUESTV2 } from "../../constants/textConstants";
import * as ProxyHelper from "./ProxyHelper";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";

const HEALTHRECORDS_HEADING = "Medical Records";
const PHARMACY_HEADING = "Baylor Scott & White Pharmacy";
const ONE_ERROR_HEADING = "Thanks, you're set! Please review one error below.";
const ALL_ERROR_HEADING = "We were unable to submit your request.";
const SUCCESS_HEADING = "Thanks, you're all set!";
const GRANT_ACCESS_TO_SOMEONE_ELSE = "GRANT ACCESS TO SOMEONE ELSE";
const REQUEST_ACCESS_TO_ANOTHER_ACCOUNT = "REQUEST ACCESS TO ANOTHER ACCOUNT";
const BOTH_HEADING = "Medical Records & Baylor Scott & White Pharmacy";

let topHeading = "", combinedStatus = false, isMultiError = false;
let errorData = [], errorOn = "";

class ProxyConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.onRetry = this.onRetry.bind(this);
        this.navigateToManageAccount = this.navigateToManageAccount.bind(this);
        this.navigateToManageNotifications = this.navigateToManageNotifications.bind(this);
        this.navigateToProxyRequestDOB = this.navigateToProxyRequestDOB.bind(this);
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers, setSelectedProxyUsers, currentProxyUser, proxyRequestData } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyConfirmation.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.getProxyConfirmation();

    }

    componentDidUpdate(prevProps, prevState)
    {
        const { requestRxPending, requestEpicPending, grantEpicPending, grantRxPending } = this.props;
        if (prevProps.requestRxPending !== requestRxPending ||
            prevProps.requestEpicPending !== requestEpicPending ||
            prevProps.grantEpicPending !== grantEpicPending ||
            prevProps.grantRxPending !== grantRxPending) {
            this.getProxyConfirmation();
        }

    }

    onRetry(errorOnSpecific) {
        let { retryFailedProxyRequest, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        if (retryFailedProxyRequest) {
            if (!errorOnSpecific) {
                logUI(`MBHWeb.UI.ProxyConfirmation.RetryWhenBothError${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                retryFailedProxyRequest(null); //both selected.
            }
            else {
                logUI(`MBHWeb.UI.ProxyConfirmation.RetryWhenSpecificError${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
                retryFailedProxyRequest(errorOnSpecific);
            }
        }
    }

    navigateToManageAccount() {
        let { navigateToManageAccount } = this.props;
        if (navigateToManageAccount)
            navigateToManageAccount();
    }

    navigateToProxyRequestDOB() {
        let { navigateToProxyRequestDOB } = this.props;
        if (navigateToProxyRequestDOB)
            navigateToProxyRequestDOB();
    }

    navigateToManageNotifications() {
        let { navigateToManageNotifications, listOfSelectedProxyUsers, history } = this.props;      

        if (listOfSelectedProxyUsers?.length > 0) {
            history.push('/onboarding/summary');
        }
        else {           
              navigateToManageNotifications && navigateToManageNotifications();
        }
    }


    getMessages(epicErrorMessage, rxErrorMessage) {
        const { healthRecordSelected, pharmacySelected } = this.props;
        let errorHeading = "";
        let errorMessage = "";
        let heading = "";
        if (epicErrorMessage && rxErrorMessage && healthRecordSelected && pharmacySelected) {
            heading = ALL_ERROR_HEADING;
            errorHeading = BOTH_HEADING;
            errorMessage = epicErrorMessage || rxErrorMessage;
        }
        else if (epicErrorMessage && healthRecordSelected) {
            heading = !pharmacySelected ? ALL_ERROR_HEADING : ONE_ERROR_HEADING;
            errorHeading = HEALTHRECORDS_HEADING;
            errorMessage = epicErrorMessage;
        }
        else if (rxErrorMessage && pharmacySelected) {
            heading = !healthRecordSelected ? ALL_ERROR_HEADING : ONE_ERROR_HEADING;
            errorHeading = PHARMACY_HEADING;
            errorMessage = rxErrorMessage;
        }
        else {
            heading = SUCCESS_HEADING;
            errorHeading = "";
            errorMessage = "";
        }
        return { TopHeading: heading, ErrorMessage: errorMessage, ErrorHeading: errorHeading };
    }

    UpdateProxyConfirmation(epicErrorMessage, rxErrorMessage) {
        const { errorInfo, requestType, healthRecordSelected, pharmacySelected, enableProxyRequestV2, proxyRequestData, listOfSelectedProxyUsers, setSelectedProxyUsers } = this.props;
        errorData = [];
        errorOn = "";
        const messages = this.getMessages(epicErrorMessage, rxErrorMessage);
        isMultiError = messages.TopHeading === ALL_ERROR_HEADING ? true : false;
        errorOn = epicErrorMessage && rxErrorMessage ? "both" : rxErrorMessage ? "pharmacy" : epicErrorMessage ? "healthrecord" : "";
        combinedStatus = (requestType === GRANT || (requestType === REQUESTV2 && enableProxyRequestV2 && proxyRequestData.manageOwnHealthcare)) && healthRecordSelected && pharmacySelected && Tools.isEmptyString(epicErrorMessage) && Tools.isEmptyString(rxErrorMessage);
        topHeading = messages.TopHeading;
        const errorMessage = messages.ErrorMessage;
        if (errorMessage) {
            errorData.push({
                heading: messages.ErrorHeading,
                message: errorMessage,
                info: errorInfo
            });            
        }

        //If any users in the selected ProxySuggestions list encountered an error, update the error property for that user
        if (listOfSelectedProxyUsers?.length > 0) {
            const updatedList = listOfSelectedProxyUsers.map(user => (proxyRequestData.firstName === user?.proxyRequest?.receiver?.firstName && proxyRequestData.lastName === user?.proxyRequest?.receiver?.lastName
                ?
                this.logConfirmationStatusForUser(user, errorMessage, listOfSelectedProxyUsers?.length)
                : user));
            setSelectedProxyUsers(updatedList);

        }
    }

    logConfirmationStatusForUser(user, errorMessage, proxySuggestionUserCount) {

        const { useOnboardingLayout } = this.props;
        const updatedUser = {
            ...user,
            hasError: errorMessage ? true : false,
            errorMessage: errorMessage,
            isCompleted: errorMessage ? false : true
        };

        logUI(`MBHWeb.UI.ProxyConfirmation${ProxyHelper.getProxySuggestions(proxySuggestionUserCount)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`,
            new Date(), Tools.getURLPath(), { currentProxySuggestionUser: updatedUser });
        return (updatedUser);

    }

    getProxyConfirmation() {
        const { requestRxErrorMessage, requestType, requestRxPending, requestEpicPending, grantEpicErrorMessage, grantRxErrorMessage,
            requestEpicErrorMessage, grantEpicPending, grantRxPending, enableProxyRequestV2 } = this.props;

        if (requestType === GRANT && !grantEpicPending && !grantRxPending) {
            return this.UpdateProxyConfirmation(grantEpicErrorMessage, grantRxErrorMessage);
        }

        if ((requestType === REQUEST || (requestType === REQUESTV2 && enableProxyRequestV2)) && !requestEpicPending && !requestRxPending) {
            return this.UpdateProxyConfirmation(requestEpicErrorMessage, requestRxErrorMessage);
        }
    }
    handleSuccessContinue = () => {
        const { listOfSelectedProxyUsers, useOnboardingLayout, history, setSelectedProxyUsers, proxyRequestData } = this.props;
        const isProxyFlowCompletedForAllUsers = listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers.every(user => user.isChecked === true && user.isCompleted === true);
        const userCountWithErrors = listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers.reduce((accum, user) => {
            if (user.isChecked === true && user.isCompleted === true && user.hasError === true) {
                return accum + 1;
            }
            return accum;
        }, 0);

        const userCountWithSuccess = listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers.reduce((accum, user) => {
            if (user.isChecked === true && user.isCompleted === true && user.hasError === false) {
                return accum + 1;
            }
            return accum;
        }, 0);

        if (useOnboardingLayout && listOfSelectedProxyUsers?.length > 0) {
            logUI(`MBHWeb.UI.ProxyConfirmation.Continue.Clicked${ProxyHelper.getProxySuggestions(listOfSelectedProxyUsers?.length)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath(), { isProxyFlowCompletedForAllUsers });

            listOfSelectedProxyUsers?.length > 0 && !isProxyFlowCompletedForAllUsers ? history.push('/onboarding/proxyrequestDOB') :
                listOfSelectedProxyUsers?.length > 0 ?
                    (logUI(`MBHWeb.UI.ProxyConfirmation.Continue.Clicked.Summary${ProxyHelper.getProxySuggestions(listOfSelectedProxyUsers?.length)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`,
                        new Date(), Tools.getURLPath(), { userCountWithSuccess, userCountWithErrors }),
                        history.push('/onboarding/summary')) :
                    history.push('/onboarding/managenotifications')

            return;
        }


        history.push('/onboarding/managenotifications');


    }
    
    render() {
        const { accessToAnotherAccountPath, userPharmacy, proxyRequestData, requestRxErrorMessage, requestType, switchToPharmacy,
            requestRxPending, requestEpicPending, healthRecordSelected, pharmacySelected, isMinor, hideRetry,
            grantEpicErrorMessage, grantRxErrorMessage, requestEpicErrorMessage, grantEpicPending, grantRxPending, enableProxyRequestV2, showManageAccountAccess, useOnboardingLayout,
            isFromInHome, listOfSelectedProxyUsers
        } = this.props;

        //this.getProxyConfirmation();

        return (<div className="proxy-confirmation-container row">
            {requestRxPending || requestEpicPending || grantEpicPending || grantRxPending ?
                <div className="col-12 maxWidth-content"><Spinner /></div> :
                <React.Fragment>
                    <div className="col-12">
                        <StatusBanner bannerMsg={topHeading} failedStatus={isMultiError} bannerAlignment="left" />
                    </div>
                    <div className={"col-12 maxWidth-content confirmation-summary-container"}>
                        {errorData && errorData.length > 0 &&
                            <Error errorData={errorData} errorOn={errorOn} onRetry={this.onRetry} hideRetry={hideRetry} navigateToManageAccount={this.navigateToManageAccount} showManageAccountAccess={showManageAccountAccess} useOnboardingLayout={useOnboardingLayout} navigateToManageNotifications={this.navigateToManageNotifications} navigateToProxyRequestDOB={this.navigateToProxyRequestDOB} proxyRequestData={proxyRequestData} />
                        }
                        {/* TODO : We are not combining the error message from the two apis because we do not know various messages from mychart request API*/}
                        {combinedStatus && (requestType === GRANT || (requestType === REQUESTV2 && enableProxyRequestV2)) ?
                            <ProxyConfirmationStatus
                                firstName={proxyRequestData.firstName}
                                lastName={proxyRequestData.lastName}
                                heading={BOTH_HEADING}
                                requestType={requestType}
                                enableProxyRequestV2={enableProxyRequestV2}
                                manageOwnHealthcare={proxyRequestData.manageOwnHealthcare}
                                status={"Pending Approval"}
                            />
                            :
                            <>
                                {healthRecordSelected && Tools.isEmptyString(grantEpicErrorMessage) && Tools.isEmptyString(requestEpicErrorMessage) &&
                                    <ProxyConfirmationStatus
                                        userPharmacy={userPharmacy}
                                        firstName={proxyRequestData.firstName}
                                        lastName={proxyRequestData.lastName}
                                        selected="healthRecordSelected"
                                        heading={HEALTHRECORDS_HEADING}
                                        status={"Pending Approval"}
                                        isMinor={isMinor}
                                        requestType={requestType}
                                        manageOwnHealthcare={proxyRequestData.manageOwnHealthcare}
                                        enableProxyRequestV2={enableProxyRequestV2}
                                        useOnboardingLayout={useOnboardingLayout}
                                    />
                                }
                                {pharmacySelected && Tools.isEmptyString(grantRxErrorMessage) && Tools.isEmptyString(requestRxErrorMessage) &&
                                    <ProxyConfirmationStatus
                                        switchToPharmacy={switchToPharmacy}
                                        userPharmacy={userPharmacy}
                                        firstName={proxyRequestData.firstName}
                                        lastName={proxyRequestData.lastName}
                                        selected="pharmacySelected"
                                        heading={PHARMACY_HEADING}
                                        status={isMinor ? "Approved" : "Pending Approval"}
                                        isMinor={isMinor}
                                        requestType={requestType}
                                        manageOwnHealthcare={proxyRequestData.manageOwnHealthcare}
                                        enableProxyRequestV2={enableProxyRequestV2}
                                        useOnboardingLayout={useOnboardingLayout}
                                    />
                                }
                            </>
                        }
                        {/* TODO : We need to check errorMessage from HealthRecord when API is there */}

                        {useOnboardingLayout && (errorData.length === 0) ?
                            <div className="row">
                                <div className="col-12 col-sm-4 form-group ">
                                    <button className="btn btn-primary" onClick={()=>this.handleSuccessContinue()}>CONTINUE</button>
                                </div>
                            </div>
                            :
                            (healthRecordSelected || pharmacySelected) && (errorData.length === 0) &&
                            <Link className="btn btn-primary" to={{ pathname: accessToAnotherAccountPath }} onClick={this.props.grantAccessToSomeone}>{requestType === GRANT ? GRANT_ACCESS_TO_SOMEONE_ELSE : REQUEST_ACCESS_TO_ANOTHER_ACCOUNT}</Link>
                        }
                        <div className="conf-buttons">
                            {isFromInHome && <Link className="btn btn-primary" to={{ pathname: '/inhomeschedule/s1' }} onClick={
                                logUI(`MBHWeb.UI.ProxyConfirmation.BackToInHomeScheduling`, new Date(), Tools.getURLPath())
                            }>RETURN TO IN-HOME SCHEDULING</Link>}
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        listOfSelectedProxyUsers: state.session.selectedProxySuggestionUsers,
        useOnboardingLayout: state.session.useOnboardingLayout,
        history: state.session.history
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProxyFlowStatus: (selectedUser) => dispatch({ type: types.GET_PROXY_USER_PROXYFLOW_STATUS, selectedUser }),
        setSelectedProxyUsers: (selectedProxySuggestionUsers) => dispatch({ type: types.SET_PROXY_SELECTED_USERS, selectedProxySuggestionUsers })
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ProxyConfirmation);